<template>
  <div v-if="shiur" class="page-container py-4 torah-single-page">
    <bio type="torah" :magidShiur="shiur.speaker"></bio>
    <div class="d-flex flex-wrap justify-content-between align-items-center my-5 text-blue px-5 py-4 torah-single-card border">
      <div class="col">
        <strong>{{ shiur.topic.name }} » {{ shiur.name }}</strong>
        <span
          v-b-tooltip.hover
          :title="isShiurimSaved ? $_t('KW:removeSavedShiurim') : $_t('KW:saveShiurim')"
          role="button"
          class="bookmark-icon ml-4"
          @click="saveShiurEvent"
        >
          <i class="fa" :class="isShiurimSaved ? 'fa-bookmark' : 'fa-bookmark-o'"></i>
        </span>
      </div>
      <span class="col-auto">{{ shiur.recorded }}</span>
      <span class="col-auto">{{ shiur.length }}</span>
      <div class="col-md-auto col-12">
        <action-buttons :magid-shiur="shiur.speaker" :shiurim="shiur" type="torah"></action-buttons>
      </div>
      <h5 class="col-12 text-darkgray mt-1" v-if="shiur.note">
        {{ $t('noteOnShiur') }}
      </h5>
      <div class="col-12 text-darkgray" v-if="shiur.note" v-html="shiur.note"></div>
    </div>
    <div v-if="shiur.speaker" class="title d-flex flex-wrap justify-content-between align-items-center text-blue mb-2">
      <h5 class="mb-0">{{ $t('moreShiurimBy') }}: {{ shiur.speaker.name }}</h5>
    </div>
    <shiurim-table :magid-shiur="shiur.speaker" />
  </div>
</template>
<script>
import BioComponent from './magideiShiur/bio.vue';
import ShiurimTableComponent from './torahShiurim/MagidShiurTable.vue';
import ActionButtonsComponent from './partials/ActionButtons.vue';

export default {
  metaInfo: function() {
    return {
      title: this.metaTitle,
      meta: [{ name: 'description', content: this.metaDescription }],
    };
  },
  i18nOptions: {
    namespaces: 'pages',
    keyPrefix: 'torahShiurSingle',
  },
  components: {
    Bio: BioComponent,
    ShiurimTable: ShiurimTableComponent,
    ActionButtons: ActionButtonsComponent,
  },
  data: function() {
    return {
      loading: false,
      shiur: null,
    };
  },
  created: function() {
    this.getData();
  },
  computed: {
    metaTitle: function() {
      return this.shiur && this.shiur.name;
    },
    metaDescription: function() {
      return this.shiur ? this.$_t('KW:site.metaWithName', { name: this.shiur.name }) : this.$_t('KW:site.metaWithoutName');
    },
    isShiurimSaved: function() {
      if (this.$store.getters['auth/isLoggedIn']) {
        return this.$store.state.profile.savedShiurim.some(save => {
          return save.id === this.shiur.id;
        });
      }
      return false;
    },
  },
  methods: {
    getData: function() {
      this.$http.get('/api/shiur/torah/' + this.$route.params.id).then(response => {
        this.shiur = response.data;
      });
    },
    saveShiurEvent() {
      if (!this.$store.getters['auth/isLoggedIn']) {
        this.$store.dispatch('auth/showModal');
        return;
      }
      if (this.isShiurimSaved) {
        this.deleteShiurimForUser();
      } else {
        this.saveShiurimForUser();
      }
    },
    saveShiurimForUser() {
      this.$http.post('/api/user/save-shiur/' + this.shiur.id).then(response => {
        let savedShiurim = this.$store.state.profile.savedShiurim;
        savedShiurim.push(response.data);
        this.$store.dispatch('profile/loadSavedShiurim', savedShiurim);
      });
    },
    deleteShiurimForUser() {
      this.$http.post('/api/user/remove-shiur/' + this.shiur.id).then(response => {
        let savedShiurim = this.$store.state.profile.savedShiurim;
        savedShiurim = savedShiurim.filter(save => save.id !== this.shiur.id);
        this.$store.dispatch('profile/loadSavedShiurim', savedShiurim);
      });
    },
  },
};
</script>
